import { ReactElement } from 'react';

import {
   Button,
   ButtonVariant,
   CheckIcon,
   IconFillColor,
   IconSize,
   IconWrapper,
   StyledFlex,
   Text,
} from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { historicalVisitTranslationKeys } from '../../../../../translations';
import { NotCopiedPrescriptionSummaryItem } from '../../copyPrescription.types';
import { CopySummaryRow } from '../CopySummaryTable.types';

const t = historicalVisitTranslationKeys.copyPrescription;

type ResultCellProps = {
   readonly copyResult: CopySummaryRow;
   readonly onReplace: (item: NotCopiedPrescriptionSummaryItem) => void;
   readonly notCopiedSummaryItems: readonly NotCopiedPrescriptionSummaryItem[];
};

export const ResultCell = (props: ResultCellProps): ReactElement => {
   if (props.copyResult.type === 'copied' || props.copyResult.type === 'replaced') {
      return (
         <StyledFlex alignItems={'center'} gap={'4px'}>
            <IconWrapper testId={'successIcon'} size={IconSize.SMALL} fillColor={IconFillColor.SUCCESS}>
               <CheckIcon />
            </IconWrapper>
            <Text testId={'copiedLabel'}>
               <Translate>{t.copied}</Translate>
            </Text>
         </StyledFlex>
      );
   }

   const summaryItem = props.notCopiedSummaryItems.find((item) => item.medicineId === props.copyResult.medicineId);

   if (!summaryItem) {
      return <></>;
   }

   return (
      <Button
         testId={'chooseReplacement'}
         label={t.chooseReplacement}
         variant={ButtonVariant.SECONDARY}
         compact
         onClick={() => props.onReplace(summaryItem)}
      />
   );
};
